import { EditIcon } from '@/src/components/EditableTable/EditableTable';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { modal } from '@/src/utils/Modal';
import { cloneDeep, get } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { Button, SizeFittingTable } from 'src/components/Antd';
import { getSalesChannels } from 'src/constrains/GlobalProvider/slice';
import _Query from 'src/constrains/Query1'; //, { EnumQueryType }
import { EnumFilterType } from 'src/constrains/Query1/Filter';
import { onTagClose1 } from 'src/constrains/Query1/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import {
  deleteProductTag,
  getProductTags,
  saveProductTag,
} from 'src/request/settings/tag';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EnumTablePosition } from 'src/types/common/common';
import Input from './TableInput';
import css from './css.module.less';

const permissions = () => {
  const view_store_tags = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsStoreTagManager,
        operation: EnumOperation.view_store_tags,
      }),
    ],
  });
  const add_edit_tag = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsStoreTagManager,
        operation: EnumOperation.add_edit_tag,
      }),
    ],
  });
  const delete_tag = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsStoreTagManager,
        operation: EnumOperation.delete_tag,
      }),
    ],
  });
  return {
    view_store_tags,
    add_edit_tag,
    delete_tag,
  };
};

const ProductTag = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { view_store_tags, add_edit_tag, delete_tag } = permissions();
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [search, setSearch] = React.useState({ search: [], filter: {} });
  const salesChannels = useSelector(getSalesChannels());

  const filters = [
    {
      type: EnumFilterType.MultipleSelection,
      searchable: true,
      dropdownProps: { name: getI18n('general.sider.salesChannel') },
      keyWord: 'salesChannel',
      options: salesChannels.map((i) => {
        return { label: i.name, value: i.uuid };
      }),
    },
  ];

  React.useEffect(() => {
    if (view_store_tags) {
      getProductTags().then((res) => {
        setLoading(false);

        setData(res || []);
      });
    } else {
      setLoading(false);
    }
  }, []);
  const searchText = search.search.map((i) => i.value);
  const searchSalesChannel = (get(search, 'filter.salesChannel') || []).map(
    (i) => i.value,
  );
  // console.log('searchText', searchText);
  const displayData = data.filter((i) => {
    const { name, salesChannelUuids } = i;
    let matched = true;
    searchText.forEach((text) => {
      if (matched) {
        const _m = name.indexOf(text) !== -1;
        matched = _m;
      }
    });
    searchSalesChannel.forEach((selectedChannelUuid) => {
      if (matched) {
        matched = (salesChannelUuids || []).includes(selectedChannelUuid);
      }
    });
    return matched;
  });

  const col = (disableEdit: boolean, disableDelete: boolean) => {
    return [
      {
        title: (
          <span>
            {getI18n('storeTagManager.productTag.tagTitle')} <EditIcon />
          </span>
        ),
        dataIndex: 'sku',
        default: true,
        key: 'sku',
        minWidth: 640,
        childGenerate: (a, record) => {
          const { name, uuid, ...rest } = record;
          const occupiedList = () => {
            return data.reduce((pre, now) => {
              const { name, uuid: _u } = now;
              if (name && _u != uuid) {
                return [...pre, name];
              }
              return pre;
            }, []);
          };

          return (
            <Input
              value={name}
              isNew={!!!uuid}
              onDelete={() => {
                const d = data.filter((i) => i.uuid);
                setData(d);
              }}
              onChange={(e) => {
                setLoading(true);
                if (uuid) {
                  saveProductTag({
                    uuid,
                    name: e,
                    ...rest,
                  }).then((res) => {
                    //  console.log('res', res);
                    const { uuid: rUuid } = res;
                    const _data = data.map((i) => {
                      const { uuid: uid } = i;
                      if (uid == rUuid) {
                        return res;
                      }
                      return i;
                    });
                    setData(_data);
                    setLoading(false);
                  });
                } else {
                  //用api返回数据替换原来最后一个数据
                  saveProductTag({
                    name: e,
                    numOfProducts: 0,
                  }).then((res) => {
                    const _d = data.filter((i) => i.uuid);
                    _d.push(res);
                    setData(_d);
                    setLoading(false);
                  });
                }
              }}
              occupiedList={occupiedList()}
              disabled={disableEdit}
            />
          );
        },
      },
      {
        title: getI18n('storeTagManager.productTag.numberofProducts'),
        dataIndex: 'number',
        default: true,
        key: 'remarks',
        fixedWidth: 320,
        childGenerate: (a, record) => {
          const { numOfProducts } = record;
          return numOfProducts;
        },
      },

      {
        titleGenerate: () =>
          getI18n(
            'general.advancedFilters.commonStoreProductsWithTable.actions',
          ),
        position: EnumTablePosition.mid,
        key: 'Actions',
        default: true,
        childGenerate: (url, record, index) => {
          const { uuid, numOfProducts } = record;
          const _delete = () => {
            if (uuid) {
              deleteProductTag(uuid).then(() => {
                msg.success(
                  getI18n('storeTagManager.productTag.taghasbeenremoved'),
                );
                const d = data.filter((i) => uuid !== i.uuid);
                setData(d);
              });
            }
          };
          return (
            <Actions
              disableDelete={disableDelete}
              onDelete={() => {
                if (numOfProducts > 0) {
                  modal.error({
                    title: getI18n('storeTagManager.productTag.deleteTag'),
                    content: getI18n(
                      'storeTagManager.productTag.deleteTagContent',
                    ),
                    onOkText: getI18n('general.delete'),
                    onOk: () => {
                      _delete();
                    },
                    onCancel: () => {
                      return;
                    },
                  });
                } else {
                  _delete();
                }
              }}
            />
          );
        },
        width: 190,
      },
    ];
  };

  return (
    <SectionWrapper title={getI18n('storeTagManager.productTag.productTag')}>
      {view_store_tags && (
        <div className={css.queryContainer}>
          <_Query
            filters={filters}
            onSearchChange={(e) => {
              //console.log(e);
              const _search = [...search.search, e];
              setSearch({ ...search, search: _search });
            }}
            onFilterChange={(e) => {
              const _search = {
                ...search,
                filter: { ...(search.filter || {}), ...(e || {}) },
              };
              setSearch(_search);
              //console.log('filter', e);
            }}
            // onSortChange={handleOnSortChange}
            onTagClose={(e) => {
              const _searchConditions = cloneDeep(search);
              onTagClose1({ state: _searchConditions, item: e });
              setSearch(_searchConditions);
            }}
            data={search || []}
          />
        </div>
      )}
      <div className={css.tip}>
        {getI18n('storeTagManager.productTag.productTagTip')}
      </div>
      <SizeFittingTable
        loading={loading}
        id={'StoreSettingTagManagerProductTable'}
        dataSource={displayData}
        pagination={false}
        columns={col(!add_edit_tag, !delete_tag)}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 600 }}
      />
      <Button
        type='primary'
        className={css.btn}
        onClick={() => {
          const d = [...data, { numOfProducts: 0, uuid: null, name: '' }];
          setData(d);
        }}
        disabled={!add_edit_tag}>
        {getI18n('storeTagManager.productTag.addProductTag')}
      </Button>
    </SectionWrapper>
  );
};
export default ProductTag;
